import React from 'react';
import 'antd/dist/antd.css';
import { Card, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
// @ts-ignore
import ImagemLogo from '../../../assets/logo_dark.png';
// @ts-ignore
import imgGooglePlay from '../../../assets/cadastre-se/google-play-btn.png';
// @ts-ignore
import imgAppStore from '../../../assets/cadastre-se/app-store-btn.png';
import { useCadastreSucesso } from './useCadastreSucesso';
import './index.css';

const { Title, Paragraph } = Typography;

const CadastreSucesso: React.FC = () => {
    const { playStoreUrl, appStoreUrl } = useCadastreSucesso();

    return (
        <div className="cadastrese-sucesso-page">
            <header className="cadastrese-sucesso-hero" aria-label="GovFácil">
                <div className="cadastrese-sucesso-hero-inner">
                    <img src={ImagemLogo} alt="GovFácil" className="cadastrese-sucesso-logo" />
                </div>
            </header>
            <div className="cadastrese-sucesso-stack">
                <div className="cadastrese-sucesso-card-wrap">
                    <Card className="cadastrese-sucesso-card" bordered={false}>
                        <CheckCircleFilled className="cadastrese-sucesso-icon" aria-hidden />
                        <Title level={2} className="cadastrese-sucesso-title">
                            Pronto! Seu acesso foi criado.
                        </Title>
                        <Paragraph className="cadastrese-sucesso-text">
                            Baixe o app GovFácil na loja do seu celular e acompanhe tudo de forma simples e eficiente.
                        </Paragraph>
                        <div className="cadastrese-loja-btns">
                            <a
                                href={playStoreUrl}
                                className="cadastrese-loja-badge-link"
                                title="GovFácil no Play Store"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={imgGooglePlay} alt="Google Play" className="cadastrese-loja-badge" />
                            </a>
                            <a
                                href={appStoreUrl}
                                className="cadastrese-loja-badge-link"
                                title="GovFácil na App Store"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={imgAppStore} alt="App Store" className="cadastrese-loja-badge" />
                            </a>
                        </div>
                    </Card>
                    {/*
                    // NÃO MOSTRAR NOVO CADASTRO
                    <p className="cadastrese-sucesso-footer-note">
                        <Link to="/">Entrar no painel</Link>
                        <span className="cadastrese-sucesso-footer-sep">·</span>
                        <Link to="/cadastre-se">Novo cadastro</Link>
                    </p> */}
                </div>
            </div>
        </div>
    );
};

export default CadastreSucesso;
